export default class FuzeGamesGame{
    constructor(api) {
        this.api = api;
        this.FuzeGamesGameClass = null;
    }

    async init(instance) {
        if (!this.FuzeGamesGameClass) {
            
            if (instance.data && instance.data.cdn && instance.data.cdn.js) {
                await this.api.util.loadJS(instance.data.cdn.js);
            } else if (
                this.api.settings &&
                this.api.settings.nativeMobileApp &&
                this.api.settings.widgetsUrl &&
                this.api.settings.widgetsUrl.fuzeGamesGame &&
                this.api.settings.widgetsUrl.fuzeGamesGame.js
            ) {
                await this.api.util.loadJS([this.api.settings.widgetsUrl.fuzeGamesGame.js]);
            }

            if (instance.data && instance.data.cdn && instance.data.cdn.css) {
                await this.api.util.loadCSS(instance.data.cdn.css);
            } else if (
                this.api.settings &&
                this.api.settings.nativeMobileApp &&
                this.api.settings.widgetsUrl &&
                this.api.settings.widgetsUrl.fuzeGamesGame &&
                this.api.settings.widgetsUrl.fuzeGamesGame.css
            ) {
                await this.api.util.loadCSS([this.api.settings.widgetsUrl.fuzeGamesGame.css]);
            }
            
            this.FuzeGamesGameClass = new window.Widget_fuzeGamesGame.default(this.api, instance.instance);
    
        }
    }

    reset() {
        if (this.FuzeGamesGameClass) {
            this.FuzeGamesGameClass.destroy()
            this.FuzeGamesGameClass = undefined;
        }
    }
}
